import React from 'react';

const ElectionPage = () => {
  // Styles defined as a string to keep the file "All-in-One"
  const styles = `
    .election-body {
      margin: 0;
      padding: 0;
      min-height: 100vh;
      font-family: 'FoundryContextW03Md', Helvetica, sans-serif;
      background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
      color: #ffffff;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
    }

    .election-container {
      width: 100%;
      max-width: 1000px;
      padding: 60px 20px;
    }

    .election-header {
      text-align: left;
    }

    .election-header h1 {
      font-size: clamp(2.5rem, 6vw, 4rem);
      font-family: 'FoundryContextW03Bd', Helvetica, sans-serif;
      font-weight: 900;
      text-transform: uppercase;
      color: #9c59d1;
      margin: 0;
      letter-spacing: -2px;
      line-height: 1;
    }

    .election-desc {
      margin-top: 15px;
      font-size: 1.1rem;
      color: #a0a0c5;
      max-width: 550px;
      line-height: 1.6;
    }

    .election-line {
      border: none;
      height: 3px;
      background: linear-gradient(90deg, #9c59d1 0%, rgba(156, 89, 209, 0) 100%);
      margin: 40px 0;
      width: 100%;
    }

    .election-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }

    .election-card {
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(156, 89, 209, 0.15);
      padding: 40px;
      text-align: left;
      cursor: pointer;
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      min-height: 200px;
      position: relative;
      overflow: hidden;
    }

    .election-card::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 0%;
      background: #9c59d1;
      transition: height 0.25s ease;
    }

    .election-card:hover {
      background: rgba(156, 89, 209, 0.08);
      border-color: #9c59d1;
      transform: translateY(-5px);
    }

    .election-card:hover::before {
      height: 100%;
    }

    .card-title {
      font-size: 1.6rem;
      font-weight: 800;
       font-family: 'FoundryContextW03Demi', Helvetica, sans-serif;
      margin: 0;
    }

    .card-desc {
      color: #8e8eb2;
      margin-top: 8px;
      font-size: 0.9rem;
      font-weight: 400;
    }

    @media (max-width: 768px) {
      .election-grid {
        grid-template-columns: 1fr;
      }
      .election-container {
        padding: 40px 20px;
      }
    }

    .election-card {
  text-decoration: none;
  color: inherit;
}

.card-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  opacity: 0.25;
  transition: opacity 0.25s ease, transform 0.25s ease;
  z-index: 0;
}

.election-card:hover .card-bg {
  opacity: 0.45;
  transform: scale(1.03);
}

.card-content {
  position: relative;
  z-index: 1;
}
  `;

  const menuItems = [
  {
    title: 'Vote',
    desc: 'Access the Electronic Ballot System',
    image: '/images/vote.jpg',
    link: '/election/vote'
  },
  {
    title: 'Party List',
    desc: 'Registered factions and representatives',
    image: '/images/parties.jpg',
    link: 'https://discord.com/channels/1175757068779663410/1457744229110386886'
  },
  {
    title: 'Constituencies',
    desc: 'Regional division and seat allocation',
    image: '/images/regions.jpg',
    link: 'https://discord.com/channels/1175757068779663410/1459393456869740654'
  },
  {
    title: 'Help',
    desc: 'Election laws and technical support',
    image: '/election/help.jpg',
    link: 'https://discord.com/channels/1175757068779663410/1454383448885035068'
  }
];

  return (
    <div className="election-body">
      <style>{styles}</style>
      
      <div className="election-container">
        <header className="election-header">
          <h1>Parliamentary<br/>Election</h1>
          <p className="election-desc">
            Official digital governance portal. Review candidates and cast your 
            authenticated vote for the upcoming legislative term.
          </p>
        </header>

        <div className="election-line"></div>

       <main className="election-grid">
  {menuItems.map((item, index) => (
    <a
      key={index}
      href={item.link}
      className="election-card"
    >
      {/*<div
        className="card-bg"
        style={{ backgroundImage: `url(${item.image})` }}
      />*/}

      <div className="card-content">
        <h2 className="card-title">{item.title}</h2>
        <p className="card-desc">{item.desc}</p>
      </div>
    </a>
  ))}
</main>

      </div>
    </div>
  );
};

export default ElectionPage;